import { render } from "./Import.vue?vue&type=template&id=1e95a61e&ts=true"
import script from "./Import.vue?vue&type=script&lang=ts"
export * from "./Import.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__